import { Injectable } from "@angular/core";
import { TranslateService } from "@ngx-translate/core";
import { DTMessagesDTO } from '@signature-it/ngx-generic/models';

declare let _: any;

@Injectable()
export class DTMessagesService {
    protected _messages: DTMessagesDTO = new DTMessagesDTO();

    constructor(public translateSvc: TranslateService) {}

    create(attributes?: object) {
        attributes = _.assign({}, this._messages, (attributes || {}));

        attributes['emptyMessage'] = this.translateSvc.instant(attributes['emptyMessage']);
        attributes['totalMessage'] = this.translateSvc.instant(attributes['totalMessage']);
        attributes['selectedMessage'] = this.translateSvc.instant(attributes['selectedMessage']);

        this._messages = new DTMessagesDTO(attributes);
        return this._messages;
    }
}
